import {AbstractFindOneService} from './abstractFindOneService';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';

export abstract class AbstractFindOneByAttributeService<StoredEntity, Entity> extends AbstractFindOneService<StoredEntity, Entity> {

    protected readonly entityDataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>;

    protected onEntityLoaded(entity: Entity) {

    }

    protected constructor(service: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>) {
        super(service, dataService);
        this.entityDataService = dataService;
    }

    loadEntity(value: any): Promise<Entity> {
        const attributeName = this.getAttributeName();
        this.value = value;
        this.setLoading(true);
        this.setError(undefined);
        this.setEntity(undefined);
        const path = attributeName === 'id' ? ('' + value) : 'one-by-' + this.getAttributeName() + '/' + value;

        return new Promise((resolve, reject) => {
            this.entityDataService.getOneWithQuery(this.buildFullPath(path)).toPromise()
                .then((data) => {
                    if (data) {
                        const entityToStore: StoredEntity = this.dataService.buildStoredEntityEntity(data);
                        this.id = this.repository.selectId(entityToStore);
                        this.setEntity(data);
                        console.log(['AbstractFindOneByAttributeService.loadEntity() data: ', data]);
                    }
                    this.onEntityLoaded(data);
                    resolve(data);
                })
                .catch((e) => {
                    this.setError(e);
                    reject(e);
                })
                .finally(() => {
                    this.setLoading(false);
                });
        });
    }

    public reload(): Promise<Entity> {
        if (this.value) {
            return this.loadEntity(this.value);
        }
        return Promise.resolve(undefined);
    }

    protected abstract getAttributeName(): string;

    private buildFullPath(path: string): string {
        return path + (this.dataService.isDtoSummary() ? '/summary' : '');
    }


}
